export const RestrictionNames = {
  sameLicensePlate: 'sameLicensePlate',
} as const;
export type RestrictionNames =
  typeof RestrictionNames[keyof typeof RestrictionNames];

export type Restrictions = {
  [key in RestrictionNames]: {
    minutes: number;
    redirectUri?: string;
    maxDuplicates?: number;
    allowCreation?: boolean;
  };
};

export type RestrictionResult = (Restrictions[keyof Restrictions] & {
  name: RestrictionNames;
})[];
